import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageWithText16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconImageWithText16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1.75L7.6 9.2l.227-.302.352.135L14 11.272V4a1 1 0 0 0-1-1m2 8.99V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-1.988zM6 13l2.173-2.898 5.774 2.22A1 1 0 0 1 13 13zm4.75-6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M3 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageWithText16);
